import React from 'react'

const Passes = () => {
  return (
    <div className='passes-container'>
        <h3>View Passes We’ve Made <br /> Available For You</h3>
        <button>View Passes</button>
    </div>
  )
}

export default Passes